module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "story"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("CHANGE THE STORY, CHANGE THE FUTURE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Choice-making beings of many possibilities, we humans live by shared cultural stories. They are the lens through which we view reality. They shape what we most value as a society and the institutions by which we structure power.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("When we get our story wrong, we get our future wrong.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("We are in terminal crisis because we have our defining story badly wrong. Seduced by a fabricated Sacred Money and Markets story, we live in indentured service to money-seeking corporate robots and relate to Earth as if it were a dead rock for sale.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Communications technologies now give us the capacity as a species to choose our common story with conscious intention. This is a moment of unprecedented opportunity to create a future consistent with our true nature and possibility as living beings born of a Living Earth born of a Living Universe.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("An authentic Sacred Life and Living Earth story is emerging. It has ancient roots in indigenous wisdom. If embraced, it changes everything.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Change the story, change the future.")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9b3e378","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/story.vue
// module id = 87
// module chunks = 0